import { useEffect, useState } from "react";

const KEY = "speedex_cookie_consent";
const EVENT = "speedex-consent-change";

export const getConsent = () => localStorage.getItem(KEY);

export const setConsent = (value) => {
  localStorage.setItem(KEY, value);
  window.dispatchEvent(new Event(EVENT));
};

export const resetConsent = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVENT));
};

export function useConsent() {
  const [consent, setState] = useState(getConsent());
  useEffect(() => {
    const update = () => setState(getConsent());
    window.addEventListener(EVENT, update);
    return () => window.removeEventListener(EVENT, update);
  }, []);
  return consent;
}
